module.exports = __webpack_public_path__ + "media/images/flags/4x3/jam-818a3c55187b137fcb85b5d9fb9c8136.svg";